//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLIENTES E USUÁRIOS DESLOGADOS:                //   
//                                                      //   
//  APARECE COMO CABEÇALHO DA PÁGINA HOME               //
//                                                      //   
//  FUNCIONALIDADE: OPÇÕES DE LOGIN,                    //
//    LOGOUT, ABRIR O CARRINHO, PESQUISAR               //
//    POR TEXTO E MOSTRAR O LOGO                        //
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import Logo from './header/logo';
import Pesquisar from  './header/pesquisar';
import CarrinhoButton from  './header/carrinho_button';
import LoginButton from  './header/login_button';
import LogoutButton from  './header/logout_button';

import '../assets/css/local/header.css';


function Header(props) {

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'Logo' -> FOTO DO LOGO DA IMAGINARIUM
      // 'Pesquisar' -> FILTRO GERAL POR TEXTO
      // 'CarrinhoButton' -> ABRE ABA LATERAL DIREITA DE CARRINHO (CASO CLIENTE) E OPÇÕES DE PERFIL (CASO FRANQUEADO)
      // 'LoginButton' -> ÍCONE DE LOGIN QUE REDIRECIONA PARA A PÁGINA DE LOGIN E CRIAR USUÁRIO
      // 'LogoutBurron' -> ÍCONE DE LOGOUT QUE ABRE OPÇÕES DE PERFIL (CASO CLIENTE) E REALIZA LOGOUT (CASO FRANQUEADO)

    return (
        <div>
            <div className="pb-3 border-header header-top">
                <div className="row col col-12 m-0 pt-3">          
                    <Logo />
                    <Pesquisar callback={props.callback}/>
                    <CarrinhoButton />
                    <LoginButton />
                    <LogoutButton />
                </div>
            </div>      
        </div>
    );
  }

  export default Header;
  